import classNames from 'classnames';
import ArrowRec from '@alltrails/shared/icons/ArrowRec';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import { MEDIA_QUERY_SMALL_DOWN } from 'utils/constants/breakpoints';
import * as styles from './HeroImage.module.scss';

type ImageSource = { src: string; mobileSrc: string };

type HeroImageProps = {
  backgroundImage: { jpg: ImageSource; webp: ImageSource; avif: ImageSource; alt: string };
  headerText: string;
  headerSubText: string;
  onArrowClick: () => void;
  imgClassName?: string;
  textContainerClassName?: string;
  arrowAlt?: string;
};

const HeroImage = ({
  backgroundImage,
  headerText,
  headerSubText,
  onArrowClick,
  imgClassName,
  textContainerClassName,
  arrowAlt
}: HeroImageProps): JSX.Element => {
  const { jpg, avif, webp } = backgroundImage;
  return (
    <div className={styles.container}>
      <picture>
        <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={avif.mobileSrc} type="image/avif" />
        <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={webp.mobileSrc} type="image/webp" />
        <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={jpg.mobileSrc} type="image/jpg" />
        <source srcSet={avif.src} type="image/avif" />
        <source srcSet={webp.src} type="image/webp" />
        <img alt={backgroundImage.alt} src={jpg.src} className={classNames(styles.hero, imgClassName)} />
      </picture>
      <div className={classNames(styles.innerContainer, textContainerClassName)}>
        <h1 className={styles.headerText}>{headerText}</h1>
        <span className={styles.headerSubtext}>{headerSubText}</span>
      </div>
      <div className={styles.largeArrow}>
        <IconButton
          icon={{ Component: ArrowRec, orientation: 'down' }}
          onClick={onArrowClick}
          testId="hero-image-down-arrow"
          title={arrowAlt}
          size="lg"
          variant="transparent"
        />
      </div>
    </div>
  );
};

export default HeroImage;
